import { defineComponent, type PropType } from 'vue'
import moment, { type Moment } from 'moment'
import { type CalendarDay, useCalendar, useCalendarTemplate } from '../../composables'

import '../calendar.sass'

export default defineComponent({
  props: {
    onSetDay: {
      type: Function as PropType<(dates: Moment[]) => void>,
      required: true,
    },
    days: {
      type: Object as PropType<Moment[]>,
      required: true,
    },
    disablePastDates: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const todayDate = moment().format('DD-MM-YYYY')

    const findDay = (date: Moment) => props.days.find((day) => day.isSame(date, 'day'))

    const isSelected = (date: Moment) => Boolean(findDay(date))

    const toggleDay = (date: Moment) => {
      const day = findDay(date)

      if (day) {
        const days = [...props.days]
        days.splice(props.days.indexOf(day), 1)

        if (props.onSetDay) props.onSetDay(days)
      } else if (props.onSetDay) props.onSetDay([...props.days, date])
    }

    const calendar = useCalendar(moment(), { disablePastDates: props.disablePastDates })

    const formatDaysForCalendar = (day: CalendarDay) => {
      let cls = ''
      if (day.faded || day.disabled) cls += ' faded'
      if (isSelected(day.date)) cls += ' selected'
      if (todayDate === day.date.format('DD-MM-YYYY')) cls += ' today'

      return (
        <div class={`ark-ui-calendar-day ${cls}`} onClick={() => { if (!day.disabled) toggleDay(day.date) }}>
          <div class="ark-ui-calendar-day-border">
            { day.date.format('D') }
          </div>
        </div>
      )
    }

    return () => {
      const days = calendar.days.value.map(formatDaysForCalendar)

      return (
        <div class="ark-ui-single-calendar">
          { useCalendarTemplate(calendar, days) }
        </div>
      )
    }
  },
})
